<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
        <v-btn fab small v-on="on">
          <v-icon class="schema-edit-icon" dark>edit</v-icon>
        </v-btn>
      </slot>
    </template>

    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ title }}
      </v-card-title>

      <v-card-text>
        <v-select v-model="model.value" :item-text="itemText" :item-value="itemValue" :items="items"
                  @change="picked"></v-select>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false">Zamknij</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
export default {

  name: "DialogPicker",
  props: ['title', 'itemText', 'itemValue', 'items', 'init'],
  data() {
    return {
      dialog: false,
      model: {
        value: null
      },
    }
  },
  created() {
    if (this.init) {
      this.model.value = parseInt(this.init)
    }
  },
  methods: {
    picked() {
      this.$emit('picked', this.model.value)
      this.dialog = false
    }
  },
}
</script>

<style scoped>

</style>